import { render } from "./PageSidebar.vue?vue&type=template&id=29b06476&scoped=true"
import script from "./PageSidebar.vue?vue&type=script&lang=js"
export * from "./PageSidebar.vue?vue&type=script&lang=js"

import "./PageSidebar.vue?vue&type=style&index=0&id=29b06476&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b06476"]])

export default __exports__